/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListTags } from "../funcs/skillsListTags.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSkillTagsResult } from "../models/components/listskilltagsresult.js";
import {
  ListSkillTagsRequest,
  ListSkillTagsSecurity,
} from "../models/operations/listskilltags.js";
import { unwrapAsync } from "../types/fp.js";
export type SkillTagsQueryData = ListSkillTagsResult;

export function prefetchSkillTags(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillTagsRequest | undefined,
  security?: ListSkillTagsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillTagsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSkillTagsQuery(
  client$: GramCore,
  request?: ListSkillTagsRequest | undefined,
  security?: ListSkillTagsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SkillTagsQueryData>;
} {
  return {
    queryKey: queryKeySkillTags({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillTagsQueryFn(ctx): Promise<SkillTagsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListTags(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySkillTags(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listTags", parameters];
}
